
  import { css } from 'lit';
  export const styles = css`:host{--component-size: var(--ig-size, var(--default-size)) !important}`;
  